// extracted by mini-css-extract-plugin
export default {"code":"app-portainer-components-Code-Code-module__code"};